import React from 'react';

export const GpsContext = React.createContext({});

export default (Component) => (props) => {
  return (
    <GpsContext.Consumer>
      {(gpsStore) => <Component gpsStore={gpsStore} {...props} />}
    </GpsContext.Consumer>
  );
};
